import React from "react";
import { FiX } from "react-icons/fi";

function ProjectModal({ project, onClose }) {
  if (!project) return null;

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={onClose}>
      <article className="case-modal" role="dialog" aria-modal="true" aria-label={`${project.name} case file`} onMouseDown={(event) => event.stopPropagation()}>
        <button className="modal-close" type="button" onClick={onClose} aria-label="Close case file">
          <FiX />
        </button>
        <p className="system-path">CLASSIFIED CASE FILE</p>
        <h2>{project.name}</h2>
        <span className="status-pill">{project.status}</span>
        <div className="case-grid">
          <div>
            <h3>Problem Solved</h3>
            <p>{project.problem}</p>
          </div>
          <div>
            <h3>Outcome</h3>
            <p>{project.result}</p>
          </div>
        </div>
        <h3>Tools Used</h3>
        <div className="tool-row">
          {project.tools.map((tool) => <span key={tool}>{tool}</span>)}
        </div>
      </article>
    </div>
  );
}

export default ProjectModal;
